/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from '../../mutation-types';

const state = {
  parkings: [],
  activeParkings: [],
  error: null,
  isLoading: false,
  cardListModal: {
    show: false,
    header: '',
    body: ''
  }
};

const getters = {
  parkings: state => state.parkings,
  error: state => state.error,
  isLoading: state => state.isLoading,
  cardListModal: state => state.cardListModal
};

const actions = {
  fetch({commit}, payload) {
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/products/guest-parking`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  startGuestParking({commit}, payload) {
    return Vue.http.post(
      `${process.env.BACKEND_API_URL}api/products/${payload.parking_id}/guest-parking/start`,
      payload.data
    ).catch((response) => {
      commit(mTypes.DATA_ERROR, response);
    });
  },
  stopGuestParking({commit}, payload) {
    return Vue.http.post(
      `${process.env.BACKEND_API_URL}api/products/${payload.product_id}/guest-parking/${payload.parking_id}/stop`,
      payload
    )
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  setIsLoading({commit}, isLoading) {
    commit('set-is-loading', isLoading)
  },
  showCardListModal({commit}, isVisible) {
    commit('set-card-list-visibility', isVisible)
  }
};

const mutations = {
  [mTypes.DATA_FETCHED](state, parkings) {
    state.parkings = parkings;
    state.error = null;
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error;
  },
  ['set-is-loading'](state, isLoading) {
    state.isLoading = isLoading
  },
  ['set-card-list-visibility'](state, isVisible) {
    state.cardListModal.show = isVisible
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/users/guestParkings.js